// Typelizer digest fdfa5c2b38d7e597024ec625394fdb2b
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /learners/schools/:school_id/students */
  index: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/students', params, options),
    method: 'get',
  }),

  /** POST /learners/schools/:school_id/students */
  create: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/students', params, options),
    method: 'post',
  }),

  /** GET /learners/schools/:school_id/students/new */
  new: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/students/new', params, options),
    method: 'get',
  }),

  /** GET /learners/schools/:school_id/students/:id/edit */
  edit: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /learners/schools/:school_id/students/:id */
  show: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:id', params, options),
    method: 'get',
  }),

  /** PATCH /learners/schools/:school_id/students/:id */
  update: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /learners/schools/:school_id/students/:id */
  destroy: (
    params: { schoolId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/learners/schools/:school_id/students/:id', params, options),
    method: 'delete',
  }),
}
